import { IonIcon } from '@ionic/react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { DescriptionContainer } from '../../Global/Description/descriptionStyles';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import { Gradient } from '../../Global/styles';

export const VTSwiper = styled(Swiper)`
	/* border: 1px solid blue; */
	background: var(--ion-color-primary);
	width: 100%;
	height: 100%;

	.swiper-pagination-progressbar {
		background: rgba(var(--ion-color-light-rgb), 0.25);
		/* mix-blend-mode: multiply; */
	}

	.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
		background: var(--ion-color-success);
	}
`;

export const VTSwiperSlide = styled(SwiperSlide)`
	/* border: 1px solid pink; */
	/* background: pink; */
	/* padding: 1rem; */
`;

export const FullBackgroundImg = styled(LoadingImage)`
	position: absolute;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	z-index: -1;
	top: 0;
	left: 0;
`;

export const VTModalInner = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	/* padding: 1.5rem; */
`;

export const VTIntroInner = styled(VTModalInner)`
	padding: 1.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	text-align: center;
	color: var(--ion-color-light);
	h2 {
		font-size: 40px;
		line-height: 1.2;
		font-weight: 500;
		letter-spacing: 0.2px;
		/* color: var(--ion-color-medium-tint); */
		width: 100%;
		margin: 0;
		text-shadow: 0 3px 6px rgba(var(--ion-color-primary-rgb), 0.5);
		color: inherit;
	}
	p {
		/* text-shadow: 0 3px 6px rgba(var(--ion-color-primary-rgb), 0.5); */
		color: inherit;
	}
`;

export const VTSlideInner = styled(VTModalInner)`
	padding: 3.5rem 1.5rem 6.5rem 1.5rem;
	display: flex;
	flex-direction: column;
	color: var(--ion-color-light);

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p {
		color: inherit;
	}
`;

export const BottomSheetInner = styled(VTSlideInner)`
	padding: 1rem 1.5rem 3.5rem;
`;

export const VTOutroMeta = styled.p`
	color: var(--ion-color-medium-tint);
	//text-transform: uppercase;
	width: 100%;
	border-top: 1px solid var(--ion-color-medium-tint);
	border-bottom: 1px solid var(--ion-color-medium-tint);
	padding: 1.5rem 0;
	margin: 20px 0 0;
`;

export const VTMeta = styled.p`
	padding: 0.5rem 2rem;
	width: max-content;
	background-color: var(--ion-color-success);
	border-radius: 50px;
	color: var(--ion-color-primary);
	font-size: 14px;
	font-weight: 600;
	margin: 10px auto;
`;

export const VTTrailTitle = styled.p`
	//text-transform: uppercase;
	font-size: 0.875rem;
	color: var(--ion-color-light-shade);
	margin: 0;
	flex-grow: 0;
`;

export const VTSlideTitle = styled.h2`
	margin: 0;
	font-size: 2rem;
	font-weight: 500;
	letter-spacing: 0.2px;
	flex-grow: 0;
`;

export const VTVideoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
	/* padding-bottom: 30%; */
	margin: -0.5rem;
`;

export const VTDescriptionContainer = styled.div`
	flex-grow: 1;
	overflow-y: scroll;
	overflow-x: hidden;
	border: 2px solid var(--ion-color-step-900);
	background: var(--ion-color-primary);
	border-radius: 10px;
	margin: 1rem -1rem 0;
	padding: 1rem;
	position: relative;
	/* height: calc(100vh - 180px); */
`;

// TODO: Transitions on this, touch interaction?
// Possible rethink with a drawer mechanic
// This could be then reused for the toast mechanic?
type SlideDescriptionProps = {
	$expanded?: boolean;
};

export const VTSlideDescription = styled(DescriptionContainer)<SlideDescriptionProps>`
	/* position: absolute; */
	/* bottom: 100px;
	top: unset;
	left: 1rem;
	right: 1rem; */
	padding: 0.75rem;
	border-radius: 10px;
	background: var(--ion-background-color);
	box-shadow: var(--generic-box-shadow);
	font-size: 0.9rem;
	color: var(--ion-color-light);
	max-height: ${({ $expanded }) => ($expanded ? '60vh' : '170px')};
	overflow-y: ${({ $expanded }) => ($expanded ? 'auto' : 'hidden')};
	cursor: pointer;
	transition: max-height 0.3s ease;
	blockquote {
		background-color: var(--ion-color-step-900);
	}
	div {
		color: inherit;
		overflow: ${({ $expanded }) => ($expanded ? 'visible' : 'hidden')};
		max-height: ${({ $expanded }) => ($expanded ? 'none' : '100%')};
		padding: 0;
		display: ${({ $expanded }) => ($expanded ? 'block' : '-webkit-box')};
		-webkit-line-clamp: ${({ $expanded }) => ($expanded ? 'unset' : '5')};
		-webkit-box-orient: vertical;
	}
	ul,
	ol {
		li {
			&::marker {
				color: var(--ion-color-secondary-tint);
			}
		}
	}
`;

export const VTSpacer = styled.div`
	flex-grow: 1;
`;

export const VTDescription = styled(DescriptionContainer)`
	padding: 0;
	color: var(--ion-color-light);
	blockquote {
		background-color: var(--ion-color-step-900);
	}
	ul,
	ol {
		li {
			&::marker {
				color: var(--ion-color-secondary-tint);
			}
		}
	}
`;

export const VTShortDescription = styled.p`
	font-family: var(--body-font);
	font-size: 16px;
	line-height: 1.5;
	color: var(--ion-color-light);
`;

export const VTInnerImgContainer = styled.div`
	width: 100%;
	height: 25vh;

	border-radius: 10px;
	box-shadow: var(--generic-box-shadow);
	margin: 1rem 0 0;
	flex-grow: 0;
	position: relative;
	overflow: hidden;
`;

export const VTInnerImg = styled(LoadingImage)``;

export const CloseButton = styled(IonIcon)`
	position: absolute;
	top: 1.0rem;
	right: 1rem;
	z-index: 10;
	border: 2px solid var(--ion-color-light-shade);
	/* padding-inline-start: 0 !important;
	padding-inline-end: 0 !important;
	padding: 0;
	margin: 0; */
	background: var(--ion-background-color);
	box-shadow: var(--generic-box-shadow);
	border-radius: 50%;

	font-size: 1.6rem;
	color: var(--ion-color-light);
`;

export const VTGradient = styled(Gradient)`
	/* opacity: 0; */
	background-image: linear-gradient(
		0deg,
		rgb(40, 54, 24) 4%,
		rgba(40, 54, 24, 0) 15%
	);
`;

export const TourLine = styled.div`
	position: absolute;
	z-index: 1;
	bottom: 3rem;
	height: 1rem;

	/* border-top: 1rem dotted var(--ion-color-medium); */
	width: 100%;
	background-color: var(--ion-color-light-shade);
	/* opacity: 0.7; */
`;

export const IntroTourLine = styled(TourLine)`
	border-radius: 50px 0 0 50px;
	width: 50%;
	right: 0;
`;

export const OutroTourLine = styled(TourLine)`
	border-radius: 0 50px 50px 0;
	width: 50%;
	left: 0;
`;

export const ForwardArrow = styled.div`
	position: absolute;
	z-index: 2;
	bottom: 32px;
	left: 50%;
	height: 3rem;
	width: 3rem;
	border: 2px solid var(--ion-color-light-shade);
	border-radius: 50%;
	background-color: var(--ion-background-color);
	box-shadow: var(--generic-box-shadow);
	transform: translateX(-50%) rotate(-90deg);
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		path {
			fill: var(--ion-color-light-shade);
		}
	}
`;
